<template lang="pug">
v-container
  v-dialog(v-model="dialog" max-width="400" persistent)
    v-card
      v-card-title(style="font-size: 1.5rem;")
        span Change Password
        v-spacer
        v-btn.align-right(icon depressed @click="dialog=false")
          v-icon mdi-close
      v-card-text
        v-row
          v-col(cols="12")
            v-text-field(v-model="current_password" label="Current Password" type="password")
          v-col(cols="12")
            v-text-field(v-model="new_password" label="New Password" type="password")
          v-col(cols="12")
            v-text-field(v-model="confirm_password" label="Confirm New Password" type="password")
          v-col(cols="12")
            v-btn.primary(@click="changePassword" block depressed :loading="passwordLoading") Submit
  h1 MY PROFILE
    v-progress-circular.ml-4.mb-1(v-if="loading" color="primary" indeterminate size="20")
  v-row(v-if="!loading")
    v-col(cols="12")
      v-text-field(v-model="profile.name" label="Name")
    v-col(cols="12")
      v-text-field(v-model="profile.email" label="E-mail")
    v-col(cols="12")
      v-text-field(v-model="profile.phone" label="Phone")
    v-col(cols="12")
      v-text-field(v-model="profile.kakao_id" label="Kakao ID")
    v-col(cols="12")
      v-text-field(v-model="profile.bank_name" label="Bank Name")
    v-col(cols="12")
      v-text-field(v-model="profile.bank_account" label="Bank Account")
    v-col(cols="12")
      v-btn.primary(@click="saveProfile" block depressed :loading="saveLoading") Save
    v-col(cols="12").pt-0
      v-btn.secondary(@click="dialog = true" block depressed) Change Password
</template>

<script>
export default {
  name: 'Profile',
  data: () => ({
    loading: true,
    dialog: false,
    profile: {
      name: '',
      email: '',
      phone: '',
      kakao_id: '',
      bank_name: '',
      bank_account: ''
    },
    current_password: '',
    new_password: '',
    confirm_password: '',
    saveLoading: false,
    passwordLoading: false
  }),
  mounted () {
    this.fetchProfile()
  },
  methods: {
    fetchProfile () {
      this.$axios.get(`/profile/?user_id=${this.$store.state.user.id}`)
        .then(resp => {
          Object.keys(resp.data).forEach(k => {
            this.$set(this.profile, k, resp.data[k])
          })
          this.loading = false
        })
    },
    saveProfile () {
      this.saveLoading = true
      this.$axios.post('/profile/', { user_id: this.$store.state.user.id, ...this.profile })
        .then(resp => {
          this.$store.dispatch('showSnackbar', { message: 'Profile successful saved', color: 'success' })
        })
        .catch(e => {
          this.$store.dispatch('showSnackbar', { message: 'Fail to save profile. Please contact ARBA Travel representative.', color: 'error' })
        })
        .finally(() => {
          this.saveLoading = false
        })
    },
    changePassword () {
      if (!this.current_password) {
        this.$store.dispatch('showSnackbar', { message: 'Fill in current password', color: 'error' })
        return
      }

      if (!this.new_password) {
        this.$store.dispatch('showSnackbar', { message: 'Fill in new password', color: 'error' })
        return
      }

      if (!this.confirm_password) {
        this.$store.dispatch('showSnackbar', { message: 'Fill in confirm password', color: 'error' })
        return
      }

      if (this.new_password !== this.confirm_password) {
        this.$store.dispatch('showSnackbar', { message: 'Password does not match', color: 'error' })
        return
      }

      const data = {
        username: this.$store.state.user.username,
        current_password: this.current_password,
        new_password: this.new_password
      }
      this.passwordLoading = true
      this.$axios.post('/change_password/', data)
        .then(resp => {
          this.$store.dispatch('showSnackbar', { message: 'Password successfully changed', color: 'success' })
          this.dialog = false
        })
        .catch(e => {
          console.log(e)
          this.$store.dispatch('showSnackbar', { message: 'Wrong current password', color: 'error' })
        })
        .finally(() => {
          this.passwordLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>